import { useState, useRef, useEffect } from "react";
import { motion, useAnimationControls } from "framer-motion";
import { useNavigate } from "react-router-dom";

const TEMP_PASSWORD = "5005";

export default function LoginScreen({ onAuthenticated }) {
  const [password, setPassword] = useState("");
  const controls = useAnimationControls();
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password === TEMP_PASSWORD) {
      localStorage.setItem("authenticated", "true");
      localStorage.setItem("authenticatedAt", Date.now().toString());
      onAuthenticated();
      navigate("/");
    } else {
      setPassword("");
      await controls.start({
        x: [0, -10, 10, -10, 10, 0],
        transition: { duration: 0.4 },
      });
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      className="fixed inset-0 w-full h-full bg-cover bg-center bg-no-repeat z-0"
      style={{ backgroundImage: "url('/hero.jpg')" }}
    >
      {/* Logo fade-in */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 4, delay: 0.5 }}
        className="absolute top-[28%] left-1/2 -translate-x-1/2 z-20"
      >
        <img
          src="/cp_logo.png"
          alt="CovePoint Logo"
          className="h-[30vh] max-h-[180px] w-auto object-contain mx-auto"
        />
      </motion.div>

      {/* Password Input */}
      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: -1 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 12, delay: 0.5 }}
        className="absolute bottom-4 sm:bottom-10 left-1/2 transform -translate-x-1/2 px-4 z-30"
      >
        <motion.input
          animate={controls}
          ref={inputRef}
          type="password"
          maxLength={6}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-24 text-center text-lg px-3 py-1 bg-gray-100/80 border border-gray-300 shadow rounded focus:outline-none"
        />
      </motion.form>
    </div>
  );
}
